import type { Actions } from "@typedefs/interfaces";
import type { TopbarStep } from "@typedefs/interfaces";
import type { FeActivityModule } from "@utils/moduleList";

/** Which tier the builder's main column is showing. Independent of `tabsOpen`. */
export type MainView = "tier1" | "tier2";

export enum BIntactMapState {
  DRAW_PROJECT,
  DRAW_ACTIVITY,
  PAINT_ACTIVITY,
}
export type ResultsTab = "ghg" | "biodiversity";

export interface Builder {
 tabsOpen: boolean,
 mainView: MainView,
 resultsTab: ResultsTab,
 activeAction: Actions,
 actionsList: Actions[],
 moduleList: FeActivityModule[],
 projectList: TopbarStep[],
 isFetchingData: boolean,
 currentModuleThreads: number[],
	activeThread: number | null,
	selectedLanguage: string,
	bIntactMapState: BIntactMapState | null,
	compareProjectId: string,
}